export default "__VITE_ASSET__ea220ef6__"